import DEFAULT_OPERATIONS from "@/hooks/SearchPage/searchPage.gql"
import mergeOperations from "@/util/shallowMerge"
import {
  useQuery
} from "@apollo/client"


export const useGetPageSize = () => {
  const operations = mergeOperations(DEFAULT_OPERATIONS)
  const {
    getPageSize,
  } = operations


  const {
    data: pageSizeData 
  } = useQuery(getPageSize, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  })

  const pageSize = pageSizeData && pageSizeData.storeConfig.grid_per_page

  return {
    pageSize
  }
}
